<template>
  <v-container>
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div v-html="exportHtml"></div>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      exportHtml: "",
    }
  },
  computed: {
    showFk() {
      return this.$route.params.id
    },
  },
  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      this.axios.get(`/shows/${this.showFk}/export/`).then((resp) => {
        this.exportHtml = resp.data.data
      })
    },
  },
}
</script>
